import React from 'react';
import { connect } from 'redux-bundler-react';

class MeasureToolOptions extends React.Component {
  constructor(props){
    super(props);
    this.updateUnits = this.updateUnits.bind(this);
    this.close = this.close.bind(this);
  }

  close(){
    const { doCloseModalWindow } = this.props;
    doCloseModalWindow();
  }

  updateUnits = (e) => {
    const { doUpdateMeasureUnits, measureAreaUnits, measureDistanceUnits } = this.props;
    const val = e.currentTarget.value;
    const type = e.currentTarget.dataset.type;
    const units = {
      areaUnits: measureAreaUnits,
      distanceUnits: measureDistanceUnits
    }
    units[type] = val;
    doUpdateMeasureUnits(units);
  }

  render(){
    const { theme, measureAreaUnits, measureDistanceUnits } = this.props;
    const height = 300;
    return (
      <div>
        <div className={"modal-header " + theme}>
          Measure Tool Options
        </div>
        <div className="modal-body" style={{ height: height, top: 0, bottom: 0, left: 0, right: 0 }}>
          
          
          <div className="form-group">
            <label className="control-label">Distance Units</label>
            <select onChange={this.updateUnits} value={measureDistanceUnits} data-type="distanceUnits" className="form-control" id="select">
              <option value="ft/mi">Feet / Miles</option>
              <option value="m/km">Meters / Kilometers</option>
            </select>
          </div>

          <div className="form-group">
            <label className="control-label">Area Units</label>
            <select onChange={this.updateUnits} value={measureAreaUnits} data-type="areaUnits" className="form-control" id="select">
              <option value="ft/mi">Feet / Miles</option>
              <option value="m/km">Meters / Kilometers</option>
              <option value="acres">Acres</option>
              <option value="hectares">Hectares</option>
            </select>
          </div>

        </div>
        <div className="modal-footer">
          <button className={"btn btn-theme " + theme} onClick={this.close}>
            Close
          </button>
        </div>
      </div>
    )
  }
}

export default connect(
  'doUpdateMeasureUnits',
  'doCloseModalWindow',
  'selectTheme',
  'selectMeasureAreaUnits',
  'selectMeasureDistanceUnits',
  MeasureToolOptions
);